import { createStore, applyMiddleware } from "redux";
import { createLogger } from "redux-logger";
import promise from "redux-promise";
import thunk from "redux-thunk";
// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'redu... Remove this comment to see the full error message
import reduxCatch from "redux-catch";
import { handleUnknownErrors } from "lcm-iot-commons";
import rootReducer from "../reducers";

const logger = createLogger();
const createStoreWithMiddleware = applyMiddleware(
  reduxCatch(handleUnknownErrors),
  thunk,
  promise,
  // @ts-expect-error TS(2769) FIXME: No overload matches this call.
  logger,
)(createStore);

export default function configureStore(initialState: $TSFixMe) {
  const store = createStoreWithMiddleware(rootReducer, initialState);
  return store;
}
